const GanttIcon = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Frame" clipPath="url(#clip0_75_1305)">
        <g id="Group 6212">
          <path
            id="Rectangle 3733 (Stroke)"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M1 0L0.999999 16H0L7.7486e-07 0H1Z"
            fill="#1890FF"
          />
          <rect
            id="Rectangle 3735"
            x="3.55542"
            y="5.3335"
            width="7.11111"
            height="1.77778"
            fill="#1890FF"
          />
          <rect
            id="Rectangle 3739"
            x="2.6665"
            y="1.77783"
            width="5.33333"
            height="1.77778"
            fill="#1890FF"
          />
          <rect
            id="Rectangle 3736"
            x="7.11108"
            y="8.88867"
            width="7.11111"
            height="1.77778"
            fill="#1890FF"
          />
          <rect
            id="Rectangle 3737"
            x="9.77759"
            y="12.4443"
            width="7.11111"
            height="1.77778"
            fill="#1890FF"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_75_1305">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default GanttIcon;
